module.exports = __webpack_public_path__ + "public/img/yibiaopan_zi_9.049715ec.png";